import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import { getDatabase, ref, set, get } from "firebase/database";
import { toast } from "react-toastify";
import Download from "../assets/images/karzameLogo.png";
import { getAddressFromCoordinates } from "./helper";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";

export default function ReportGenerate({ props }) {
  const currentTimeStamp = props?.currentTimeStamp || "";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [admin, setAdmin] = useState("");
  const [timestamp] = useState(new Date().toLocaleString());
  const [escortStatus, setEscortStatus] = useState("");
  const [chatTime, setChatTime] = useState("");
  const [phoneTime, setPhoneTime] = useState("");
  const [userResponse, setUserResponse] = useState("");
  const [responseTime, setResponseTime] = useState("");
  const [location, setLocation] = useState("");
  const [callMade, setCallMade] = useState("");
  const [callOutcome, setCallOutcome] = useState("");

  const [securityDispatched, setSecurityDispatched] = useState("");
  const [isDataSaved, setIsDataSaved] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [reportId, setReportId] = useState("");
  const [escortStartTime, setEscortStartTime] = useState("");
  const [escortEndTime, setEscortEndTime] = useState("");
  const [additionComments, setAdditionalComments] = useState("");
  const [guardLocation, setGuardLocation] = useState("");

  const userId = props?.userId;

  useEffect(() => {
    const getlastAddress = async () => {
      const placeName = await getAddressFromCoordinates(props?.currentLat, props?.currentLong);
      if (placeName) {
        setLocation(placeName);
      }
    };
    getlastAddress();
  }, [props?.currentLat, props?.currentLong]);

  useEffect(() => {
    if (currentTimeStamp) {
      const formattedEscortStartTime = new Date(currentTimeStamp).toISOString().slice(0, 16);
      setEscortStartTime(formattedEscortStartTime);
    }
  }, [currentTimeStamp]);

  useEffect(() => {
    if (currentTimeStamp) {
      const formattedEscortEndTime = new Date(currentTimeStamp).toISOString().slice(0, 16);
      setEscortEndTime(formattedEscortEndTime);
    }
  }, [currentTimeStamp]);

  useEffect(() => {
    if (userId) {
      fetchReportData(userId);
    }
  }, [userId]);
  useEffect(() => {
    if (isModalOpen) {
      generateReportId();
    }
  }, [isModalOpen]);
  const generateReportId = () => {
    const uniqueId = `WHG-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
    setReportId(uniqueId);
  };

  const fetchReportData = (userId) => {
    const db = getDatabase();
    const reportRef = ref(db, `users/${userId}/wellbeingReport`);

    get(reportRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          const reportData = snapshot.val();
          setAdmin(reportData.admin || "");

          setChatTime(reportData.chatTime || "");
          setPhoneTime(reportData.phoneTime || "");
          setUserResponse(reportData.userResponse || "");
          setResponseTime(reportData.responseTime || "");
          setCallMade(reportData.callMade || "");
          setCallOutcome(reportData.callOutcome || "");

          setEscortStartTime(reportData.escortStartTime || "");
          setEscortEndTime(reportData.escortEndTime || "");
          setGuardLocation(reportData.guardLocation || "");
          setLocation(reportData.selectedGuardLocation || reportData.coordinates || "");

          setEscortStatus(reportData.stillAtLocation || "");
          setSecurityDispatched(reportData.liveFeedObservation || "");
          setAdditionalComments(reportData.additionComments || "");

          setIsDataSaved(true);
        }
      })
      .catch((error) => {
        //  console.error("Error fetching report data:", error);
      });
  };

  const handleClick = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleSave = () => {
    if (
      !admin ||
      !escortStatus ||
      !chatTime ||
      !phoneTime ||
      !userResponse ||
      !callMade ||
      !callOutcome ||
      !escortStartTime ||
      !escortEndTime ||
      !location ||
      !guardLocation
    ) {
      setErrorMessage("Please fill out all required fields before saving.");
      return;
    }

    const db = getDatabase();
    const reportRef = ref(db, `users/${userId}/wellbeingReport`);

    const reportData = {
      reportId: reportId,
      userName: props?.userName,
      userPhone: props?.userPhone,
      admin: admin,
      timestamp: timestamp,
      escortStartTime: escortStartTime,
      escortEndTime: escortEndTime,
      totalDuration: "08:00",
      guardLocation: guardLocation,
      coordinates: location,
      stillAtLocation: escortStatus,
      liveFeedObservation: securityDispatched,
      chatTime: chatTime,
      phoneTime: phoneTime,
      userResponse: userResponse,
      responseTime: responseTime,
      callMade: callMade,
      callOutcome: callOutcome,
      additionComments: additionComments,
    };

    set(reportRef, reportData)
      .then(() => {
        setIsDataSaved(true);
        setErrorMessage("");
        //  console.log("Report saved successfully");
        toast.info(`Report saved successfully`, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .catch((error) => {
        setErrorMessage("Error saving report in Firebase.");
        //  console.error("Error saving report in Firebase:", error);
      });
  };

  const handleDownload = () => {
    const doc = new jsPDF();

    doc.addImage(Download, "PNG", 90, 10, 30, 30);

    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Virtual Guard Wellbeing Check Report", 105, 50, null, null, "center");

    // Section 1: Report Metadata
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 1: Report Metadata", 20, 70);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Report ID: ${reportId}`, 20, 80);
    doc.text(`User Name: ${props?.userName}`, 20, 90);
    doc.text(`Phone Number: ${props?.userPhone}`, 20, 100);
    doc.text(`Admin on Duty: ${admin}`, 20, 110);
    doc.text(`Report Timestamp: ${timestamp}`, 20, 120);

    // Section 2: Guard Details
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 2: Guard Details", 20, 140);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Guard Start Time: ${escortStartTime}`, 20, 150);
    doc.text(`Guard End Time: ${escortEndTime}`, 20, 160);
    doc.text(`Total Guard Duration: 08:00`, 20, 170);
    doc.text(`Selected Guard Location: ${guardLocation}`, 20, 180);
    doc.text(`Coordinates or Address: ${location}`, 20, 190);
    doc.text(`Still at Location: ${escortStatus}`, 20, 200);
    doc.text(`Live Feed Observations: ${securityDispatched}`, 20, 210);

    // Section 3: Wellbeing Check Actions
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 3: Wellbeing Check Actions", 20, 220);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Chat Message Sent At: ${chatTime}`, 20, 230);
    doc.text(`User Response Received: ${userResponse}`, 20, 240);
    doc.text(`Response Time: ${userResponse === "Yes" ? responseTime : "No Response"}`, 20, 250);
    doc.text(`Phone Call Attempt: ${phoneTime}`, 20, 260);
    doc.text(`Call Status: ${callMade}`, 20, 270);
    doc.text(`Outcome: ${callOutcome}`, 20, 280);
    doc.text(`Admin Comments: ${additionComments}`, 20, 290);

    doc.save("Wellbeing_Report.pdf");
  };

  return (
    <div>
      <button onClick={handleClick} className="btn btn-danger btn-sm">
        Generate Report
      </button>

      {isModalOpen && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.header}>Virtual Guard Wellbeing Check Report</h2>

            {errorMessage && <div style={styles.error}>{errorMessage}</div>}

            <div style={styles.section}>
              <h4 style={styles.sectionTitle}>Section 1: Report Metadata</h4>
              <div style={styles.row}>
                <label>Report ID: {reportId}</label>
              </div>
              <div style={styles.row}>
                <label>User Name: {props?.userName}</label>
              </div>
              <div style={styles.row}>
                <label>Phone Number: {props?.userPhone}</label>
              </div>
              <div style={styles.row}>
                <label>Admin on Duty: </label>
                <input
                  type="text"
                  value={admin}
                  onChange={(e) => setAdmin(e.target.value)}
                  placeholder="Enter admin name"
                  style={styles.input}
                />
              </div>
              <div style={styles.row}>
                <label>Time & Date of Report: {timestamp}</label>
              </div>
            </div>

            <div style={styles.section}>
              <h4 style={styles.sectionTitle}>Section 2: Guard Details</h4>

              <div style={styles.row}>
                <label>Guard Start Time:</label>
                <Datetime
                  value={escortStartTime ? moment(escortStartTime) : ""}
                  onChange={(date) => setEscortStartTime(moment(date).format("YYYY-MM-DDTHH:mm"))}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm A"
                  inputProps={{
                    placeholder: "YYYY-MM-DD HH:mm",
                    style: styles.input,
                  }}
                />
                <Datetime
                  value={escortEndTime ? moment(escortEndTime) : ""}
                  onChange={(date) => setEscortEndTime(moment(date).format("YYYY-MM-DDTHH:mm"))}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm A"
                  inputProps={{
                    placeholder: "YYYY-MM-DD HH:mm",
                    style: styles.input,
                  }}
                />
              </div>

              <div style={styles.row}>
                <label>Total Guard Duration:</label>
                <input type="text" value={"08:00"} readOnly style={styles.input} />
              </div>

              <div style={styles.row}>
                <label>Selected Guard Location:</label>
                <select
                  value={guardLocation}
                  onChange={(e) => setGuardLocation(e.target.value)}
                  style={styles.input}
                >
                  <option value="">Select Location</option>
                  <option value="Home">Home</option>
                  <option value="Office">Office</option>
                  <option value="Gate A">Gate A</option>
                </select>
              </div>

              <div style={styles.row}>
                <label>Last Known GPS Location:</label>
                <input
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  onClick={() => {
                    if (location) {
                      window.open(location, "_blank");
                    }
                  }}
                  style={{
                    ...styles.input,
                    cursor: location ? "pointer" : "default",
                    color: "#007BFF",
                    textDecoration: "underline",
                  }}
                />
              </div>

              <div style={styles.row}>
                <label>Still at Location?</label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <label>
                    <input
                      type="radio"
                      name="stillAtLocation"
                      value="Yes"
                      checked={escortStatus === "Yes"}
                      onChange={(e) => setEscortStatus("Yes")}
                    />
                    Yes
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="stillAtLocation"
                      value="No"
                      checked={escortStatus === "No"}
                      onChange={(e) => setEscortStatus("No")}
                    />
                    No
                  </label>
                </div>
              </div>

              <div style={styles.row}>
                <label>Live Feed Observations (Optional):</label>
                <input
                  type="text"
                  value={securityDispatched}
                  onChange={(e) => setSecurityDispatched(e.target.value)}
                  style={styles.input}
                  placeholder="Enter live feed observations"
                />
              </div>
            </div>

            <div style={styles.section}>
              <h4 style={styles.sectionTitle}>Section 3: Wellbeing Check Actions</h4>

              <div style={styles.row}>
                <label>Chat Message Attempt:</label>
                <Datetime
                  value={chatTime ? moment(chatTime) : ""}
                  onChange={(date) => setChatTime(moment(date).format("YYYY-MM-DDTHH:mm"))}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm A"
                  inputProps={{
                    placeholder: "YYYY-MM-DD HH:mm",
                    style: styles.input,
                  }}
                />
              </div>

              <div style={styles.row}>
                <label>User Response:</label>
                <select
                  value={userResponse}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUserResponse(value);
                    setResponseTime(value === "No" ? "No Response" : "");
                  }}
                  style={styles.input}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>

              {userResponse === "Yes" && (
                <div style={styles.row}>
                  <label>Response Time:</label>
                  <Datetime
                    value={responseTime ? moment(responseTime) : ""}
                    onChange={(date) => setResponseTime(moment(date).format("YYYY-MM-DDTHH:mm"))}
                    dateFormat="YYYY-MM-DD"
                    timeFormat="HH:mm A"
                    inputProps={{
                      placeholder: "YYYY-MM-DD HH:mm",
                      style: styles.input,
                    }}
                  />
                </div>
              )}
              {userResponse === "No" && (
                <div style={styles.row}>
                  <label>Response Time:</label>
                  <span>No Response</span>
                </div>
              )}

              <div style={styles.row}>
                <label>Phone Call Attempt:</label>
                <Datetime
                  value={phoneTime ? moment(phoneTime) : ""}
                  onChange={(date) => setPhoneTime(moment(date).format("YYYY-MM-DDTHH:mm"))}
                  dateFormat="YYYY-MM-DD"
                  timeFormat="HH:mm A"
                  inputProps={{
                    placeholder: "YYYY-MM-DD HH:mm",
                    style: styles.input,
                  }}
                />
              </div>

              <div style={styles.row}>
                <label>Call Status:</label>
                <select
                  value={callMade}
                  onChange={(e) => setCallMade(e.target.value)}
                  style={styles.input}
                >
                  <option value="">Select</option>
                  <option value="Ringing">Ringing</option>
                  <option value="Switched Off">Switched Off</option>
                  <option value="No Answer">No Answer</option>
                </select>
              </div>

              <div style={styles.row}>
                <label>Escalation Reason:</label>
                <select
                  value={callOutcome}
                  onChange={(e) => setCallOutcome(e.target.value)}
                  style={styles.input}
                >
                  <option value="">Select</option>
                  <option value="User Answered">User Answered</option>
                  <option value="No Response">No Response</option>
                  <option value="Phone Off">Phone Off</option>
                </select>
              </div>

              <div style={styles.row}>
                <label>Admin Comments (Optional):</label>
                <input
                  type="text"
                  value={additionComments}
                  onChange={(e) => setAdditionalComments(e.target.value)}
                  style={styles.input}
                  placeholder="Comments"
                />
              </div>
            </div>

            <div style={styles.actions}>
              <button className="btn btn-secondary btn-sm" onClick={handleClose}>
                Close
              </button>
              <button className="btn btn-primary btn-sm" onClick={handleSave}>
                Save
              </button>

              {isDataSaved && (
                <button className="btn btn-success btn-sm" onClick={handleDownload}>
                  Download Report
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
  },
  modal: {
    background: "#fff",
    padding: "30px",
    width: "600px",
    maxHeight: "90vh",
    overflowY: "auto",
    borderRadius: "8px",
    boxShadow: "0 0 15px rgba(0,0,0,0.3)",
  },
  header: {
    marginBottom: "20px",
    fontSize: "22px",
    textAlign: "center",
  },
  section: {
    marginBottom: "25px",
    borderBottom: "1px solid #ddd",
    paddingBottom: "15px",
  },
  sectionTitle: {
    marginBottom: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#444",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "12px",
    alignItems: "center",
    gap: "10px",
  },
  input: {
    padding: "8px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    flex: 1,
  },
  error: {
    color: "red",
    marginBottom: "15px",
    fontSize: "14px",
    textAlign: "center",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "20px",
  },
};
